import React, { useRef } from 'react'

import { ConditionalWrapper } from '@/components'
import { useInfinityListObserver } from '@/hooks'
import { FetchMoreStatus } from '@/types'
import { t } from '@/i18n'

import LoadingIndicator from '@/assets/images/loading_indicator.gif'

import DataNotFound from './NoData'
import Button from './Button'

interface IDetails {
  data: any[]
  icon?: string
  title: string
  loading?: boolean
  maxHeight?: string
  showNoData?: boolean
  withButton?: boolean
  onFetchMore?: () => void
  wrapperClassName?: string
  Header?: () => JSX.Element
  onClickViewAll?: () => void
  Wrapper?: React.ElementType
  Row: React.ElementType<any>
  listWrapperClassName?: string
  RowParent?: React.ElementType
  dataBoxWrapperClassName?: string
  onRowClick?: (item: any) => void
  TitleWrapper?: React.ElementType
  fetchMoreStatus?: FetchMoreStatus
  HeaderComponent?: React.ReactNode
}

const Details: React.FC<IDetails> = ({
  Row,
  icon,
  data,
  title,
  Header,
  loading,
  maxHeight,
  RowParent,
  onRowClick,
  onFetchMore,
  onClickViewAll,
  Wrapper = 'ul',
  HeaderComponent,
  fetchMoreStatus,
  showNoData = false,
  TitleWrapper = 'h3',
  withButton = false,
  listWrapperClassName = 'data-box',
  wrapperClassName = 'info-box w-50',
  dataBoxWrapperClassName = 'details',
}) => {
  const observerRef = useRef<HTMLDivElement>(null)

  // @ts-ignore
  useInfinityListObserver(onFetchMore, observerRef, fetchMoreStatus)
  return (
    <div className={wrapperClassName}>
      <div className="main-info">
        {HeaderComponent}
        <div className="title-box">
          <TitleWrapper>
            {!!icon && <span className={icon}></span>}
            {title}
          </TitleWrapper>
          {withButton && (
            <Button
              onClick={() => onClickViewAll?.()}
              className="main-btn blank"
            >
              {t('viewAll')}
              <span className="icon-arrow"></span>
            </Button>
          )}
        </div>
        <div className={listWrapperClassName}>
          <div className={dataBoxWrapperClassName}>
            {!data.length && loading ? (
              <div className="fetch-detail">
                <img
                  className="search-loading-indicator"
                  src={LoadingIndicator}
                />
              </div>
            ) : (
              <div className="infinite-loader-wrapper" style={{ maxHeight }}>
                <Wrapper>
                  {!!Header && <Header />}
                  <ConditionalWrapper
                    condition={!!RowParent}
                    Wrapper={RowParent}
                  >
                    {data.map((item, index) => (
                      <Row node={item} key={index} onClick={onRowClick} />
                    ))}
                  </ConditionalWrapper>
                </Wrapper>
                {!data.length && showNoData && !loading && <DataNotFound />}
                {fetchMoreStatus === 'hasNextPage' && (
                  <div ref={observerRef} className="infinite-loader">
                    <img src={LoadingIndicator} />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Details
